"use strict";

var _classCallCheck = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var elliptic_1 = require("elliptic");

var crypto_1 = require("crypto");

var key_encoder_1 = __importDefault(require("key-encoder"));

var ecdsa_sig_formatter_1 = require("ecdsa-sig-formatter");

var errors_1 = require("../errors");

var SECP256K1Client =
/*#__PURE__*/
function () {
  function SECP256K1Client() {
    _classCallCheck(this, SECP256K1Client);
  }

  _createClass(SECP256K1Client, null, [{
    key: "createHash",
    value: function createHash(signingInput) {
      return crypto_1.createHash('sha256').update(signingInput).digest();
    }
  }, {
    key: "loadPrivateKey",
    value: function loadPrivateKey(rawPrivateKey) {
      if (rawPrivateKey.length === 66) {
        rawPrivateKey = rawPrivateKey.slice(0, 64);
      }

      return SECP256K1Client.ec.keyFromPrivate(rawPrivateKey);
    }
  }, {
    key: "loadPublicKey",
    value: function loadPublicKey(rawPublicKey) {
      return SECP256K1Client.ec.keyFromPublic(rawPublicKey, 'hex');
    }
  }, {
    key: "encodePublicKey",
    value: function encodePublicKey(publicKey, originalFormat, destinationFormat) {
      return SECP256K1Client.keyEncoder.encodePublic(publicKey, originalFormat, destinationFormat);
    }
  }, {
    key: "derivePublicKey",
    value: function derivePublicKey(privateKey) {
      var compressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (typeof privateKey !== 'string') {
        throw Error('private key must be a string');
      }

      if (!/^[0-9A-F]+$/i.test(privateKey)) {
        throw Error('private key must be a hex string');
      }

      if (privateKey.length == 66) {
        privateKey = privateKey.slice(0, 64);
      } else if (privateKey.length <= 64) {// do nothing
      } else {
        throw Error('private key must be 66 characters or less');
      }

      var keypair = SECP256K1Client.ec.keyFromPrivate(privateKey);
      return keypair.getPublic(compressed, 'hex');
    }
  }, {
    key: "signHash",
    value: function signHash(signingInputHash, rawPrivateKey) {
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'jose';

      // make sure the required parameters are provided
      if (!(signingInputHash && rawPrivateKey)) {
        throw new errors_1.MissingParametersError('a signing input hash and private key are all required');
      } // prepare the private key


      var privateKeyObject = SECP256K1Client.loadPrivateKey(rawPrivateKey); // calculate the signature

      var signatureObject = privateKeyObject.sign(signingInputHash);
      var derSignature = Buffer.from(signatureObject.toDER());

      if (format === 'der') {
        return derSignature.toString('hex');
      } else if (format === 'jose') {
        // return the JOSE-formatted signature
        return ecdsa_sig_formatter_1.derToJose(derSignature, 'ES256');
      } else {
        throw Error('Invalid signature format');
      }
    }
  }, {
    key: "loadSignature",
    value: function loadSignature(joseSignature) {
      // create and return the DER-formatted signature buffer
      return ecdsa_sig_formatter_1.joseToDer(joseSignature, 'ES256');
    }
  }, {
    key: "verifyHash",
    value: function verifyHash(signingInputHash, derSignatureBuffer, rawPublicKey) {
      // make sure the required parameters are provided
      if (!(signingInputHash && derSignatureBuffer && rawPublicKey)) {
        throw new errors_1.MissingParametersError('a signing input hash, der signature, and public key are all required');
      } // prepare the public key


      var publicKeyObject = SECP256K1Client.loadPublicKey(rawPublicKey); // verify the token

      return publicKeyObject.verify(signingInputHash, derSignatureBuffer);
    }
  }]);

  return SECP256K1Client;
}();

SECP256K1Client.ec = new elliptic_1.ec('secp256k1');
SECP256K1Client.algorithmName = 'ES256K';
SECP256K1Client.keyEncoder = new key_encoder_1.default({
  curveParameters: [1, 3, 132, 0, 10],
  privatePEMOptions: {
    label: 'EC PRIVATE KEY'
  },
  publicPEMOptions: {
    label: 'PUBLIC KEY'
  },
  curve: SECP256K1Client.ec
});
exports.SECP256K1Client = SECP256K1Client;